import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, ActivityIcon } from 'lucide-react';
import { Button } from './ui/Button';
const navLinks = [{
  label: 'Programy',
  href: '#courses'
}, {
  label: 'Platforma',
  href: '#features'
}, {
  label: 'Cennik',
  href: '#pricing'
}, {
  label: 'O nas',
  href: '#about'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-gray-950/90 backdrop-blur-md border-b border-gray-800" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="flex items-center justify-between h-16" data-id="element-190">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2" data-id="element-191">
            <div className="w-8 h-8 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-lg flex items-center justify-center" data-id="element-192">
              <ActivityIcon className="w-5 h-5 text-gray-900" data-id="element-193" />
            </div>
            <span className="text-xl font-bold text-white tracking-tight" data-id="element-194">
              Winrealm
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8" data-id="element-195">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors duration-200" data-id="element-196">
                {link.label}
              </a>)}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3" data-id="element-197">
            <Button variant="ghost" size="sm" data-id="element-198">
              Zaloguj się
            </Button>
            <Button variant="primary" size="sm" data-id="element-199">
              Rozpocznij
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-gray-400 hover:text-white" aria-label="Toggle menu" data-id="element-200">
            {isOpen ? <XIcon className="w-6 h-6" data-id="element-201" /> : <MenuIcon className="w-6 h-6" data-id="element-202" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-203">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-gray-950 border-b border-gray-800" data-id="element-204">
            <div className="px-4 py-4 space-y-3" data-id="element-205">
              {navLinks.map(link => <a key={link.label} href={link.href} className="block py-2 text-gray-400 hover:text-white transition-colors" onClick={() => setIsOpen(false)} data-id="element-206">
                  {link.label}
                </a>)}
              <div className="pt-4 space-y-2" data-id="element-207">
                <Button variant="secondary" size="md" className="w-full" data-id="element-208">
                  Zaloguj się
                </Button>
                <Button variant="primary" size="md" className="w-full" data-id="element-209">
                  Rozpocznij
                </Button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}